"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Icon_1 = __importStar(require("../icon/Icon"));
var menu_list_1 = require("../menu-list");
var PositionUtils_1 = __importDefault(require("../../utils/PositionUtils"));
var Positions_1 = __importDefault(require("../../common/enums/Positions"));
var ValidationMessage_1 = __importDefault(require("../forms/common/ValidationMessage"));
var ExperimentalComponentUtils_1 = require("../../utils/ExperimentalComponentUtils");
var FieldValidationState_1 = require("../forms/common/FieldValidationState");
var Typeahead = /** @class */ (function (_super) {
    __extends(Typeahead, _super);
    function Typeahead() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.refInput = react_1.default.createRef();
        _this.refLabel = react_1.default.createRef();
        _this.typeaheadContent = react_1.default.createRef();
        _this.state = {
            suggestionList: [],
            isOpen: false,
            searchQuery: null,
            isCancel: false,
            isClearSuggestions: false,
            isOutsideWindow: false
        };
        _this.setGlobalClickHandler = null;
        _this.onBlur = function (evt) {
            var onBlur = _this.props.onBlur;
            onBlur && onBlur(evt);
        };
        _this.onFocus = function (evt) {
            var onFocus = _this.props.onFocus;
            _this.setState({ isCancel: false, isOpen: true });
            onFocus && onFocus(evt);
        };
        _this.onCancel = function () {
            var input = _this.refInput.current;
            if (input) {
                input.value = '';
                input.focus();
            }
            _this.setState({ isCancel: true });
        };
        _this.onBack = function (evt) {
            _this.setState({ isClearSuggestions: true, isOpen: false });
            // Prevent the label click from bubbling up to input focus, causing fullscreen mobile bug
            evt.preventDefault();
        };
        _this.onQuery = function (searchQuery) {
            // expose input values to wrapper component if required
            _this.props.onQuery(searchQuery);
        };
        _this.onChange = function (e) {
            var positionUtils = new PositionUtils_1.default(_this.refInput.current, _this.typeaheadContent.current, Positions_1.default.BOTTOM);
            var _a = _this.props, onQuery = _a.onQuery, useExternalDataSource = _a.useExternalDataSource, searchTermThrottle = _a.searchTermThrottle;
            var searchQuery = e && e.target && e.target.value;
            if (!searchQuery || (searchQuery && searchQuery.length < searchTermThrottle)) {
                // Set isOpen so that the input is still display as fullscreen on mobile.
                _this.setState({ isClearSuggestions: true, isOpen: true });
                // report back to parent context, even when query is empty, so that way apps know when user input is cleared
                if (useExternalDataSource && onQuery) {
                    onQuery(searchQuery);
                }
                return false;
            }
            _this.setState({
                searchQuery: searchQuery,
                isOpen: true,
                isOutsideWindow: positionUtils.isOutsideWindow(),
                isCancel: false,
                isClearSuggestions: false
            });
            if (useExternalDataSource && onQuery) {
                onQuery(searchQuery);
            }
            else {
                _this.onSearch(searchQuery);
            }
        };
        return _this;
    }
    Typeahead.prototype.componentDidMount = function () {
        var _this = this;
        document.body.addEventListener('click', this.setGlobalClickHandler = function (e) {
            _this.globalClickHandler(e);
        }, false);
    };
    Typeahead.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.isOpen !== this.state.isOpen || prevState.searchQuery !== this.state.searchQuery) {
            var positionUtils = new PositionUtils_1.default(this.refInput.current, this.typeaheadContent.current, Positions_1.default.BOTTOM);
            this.state.isOpen && positionUtils.isOutsideWindow() && this.setTypeaheadPosition();
        }
    };
    Typeahead.prototype.componentWillUnmount = function () {
        document.body.removeEventListener('click', this.setGlobalClickHandler, false);
    };
    Typeahead.prototype.setTypeaheadPosition = function () {
        var positionUtils = new PositionUtils_1.default(this.refInput.current, this.typeaheadContent.current, Positions_1.default.BOTTOM);
        var typeaheadContent = this.typeaheadContent.current;
        var contentStyleString = positionUtils.getContentStyleString();
        var dynamicStyle = contentStyleString && contentStyleString !== 'undefined' ? contentStyleString + ";" : '';
        var style = (dynamicStyle + " margin-top: 0; top: 48px;").trim();
        typeaheadContent.setAttribute('style', style);
    };
    Typeahead.prototype.globalClickHandler = function (e) {
        var typeahead = this.refLabel.current;
        if (this.state.isOpen && e.target && typeahead) {
            if (!typeahead.contains(e.target)) {
                this.setState({ isOpen: false });
            }
        }
    };
    Typeahead.prototype.onSearch = function (searchQuery) {
        var _a;
        // Search in list of array and generate suggestions list
        var _b = this.props, sourceData = _b.sourceData, sourceDataValue = _b.sourceDataValue, isSearch = _b.isSearch;
        var suggestionList = sourceData && searchQuery && sourceData.filter(function (item) {
            return item && item[sourceDataValue] && (item[sourceDataValue].toUpperCase().includes(searchQuery.toUpperCase()));
        });
        if (isSearch) {
            suggestionList && suggestionList.push((_a = {}, _a[sourceDataValue] = 'search', _a));
        }
        this.setState({
            suggestionList: suggestionList
        });
    };
    Typeahead.prototype.onSelect = function (item) {
        var _a = this.props, isSearch = _a.isSearch, sourceDataValue = _a.sourceDataValue, onSelect = _a.onSelect;
        if (isSearch && item[sourceDataValue] === 'search') {
            return false;
        }
        if (this.refInput && item) {
            this.refInput.current.value = item[sourceDataValue];
        }
        this.setState({
            isOpen: false,
            isClearSuggestions: true
        }, function () {
            onSelect && onSelect(item);
        });
    };
    Typeahead.prototype.searchItem = function (searchText, searchQuery) {
        var index = searchText && searchText.indexOf('{0}');
        var preText = searchText && searchText.substring(0, index);
        var postText = searchText && searchText.substring(index + '{0}'.length);
        return (react_1.default.createElement("label", null,
            react_1.default.createElement(Icon_1.default, { name: "search", size: Icon_1.IconSize.SMALL }),
            preText,
            react_1.default.createElement("strong", null, searchQuery),
            postText));
    };
    Typeahead.prototype.suggestionTextFormatted = function (suggestionText, searchQuery) {
        var index = suggestionText && searchQuery && suggestionText.toUpperCase().indexOf(searchQuery.toUpperCase());
        if (searchQuery && index !== null && index >= 0) {
            var prehighlightedText = suggestionText.substring(0, index);
            var hightlightedText = suggestionText.substring(index, index + searchQuery.length);
            var posthighlightedText = suggestionText.substring(index + searchQuery.length);
            return (react_1.default.createElement("span", null,
                prehighlightedText,
                react_1.default.createElement("strong", null, hightlightedText),
                posthighlightedText));
        }
        return (react_1.default.createElement("span", null, suggestionText));
    };
    Typeahead.prototype.getClassNames = function (classes, suggestions, wrapResults) {
        var _a = this.state, isOpen = _a.isOpen, isOutsideWindow = _a.isOutsideWindow, isCancel = _a.isCancel;
        return classnames_1.default('fds-typeahead', {
            'fds-typeahead-open': isCancel || isOpen && (suggestions && suggestions.length),
            'fds-typeahead-fullscreen': isOpen,
            'fds-typeahead-truncate': !wrapResults,
            'fds-position-bottom': isOpen && isOutsideWindow
        }, classes);
    };
    Typeahead.prototype.getInputClassNames = function () {
        var searchQuery = this.state.searchQuery;
        return classnames_1.default('fds-field-input', 'fds-typeahead-input', {
            'fds-typeahead-populated': searchQuery && searchQuery.length > 0
        });
    };
    Typeahead.prototype.getContentWrapperClassNames = function () {
        var _a = this.state, isOpen = _a.isOpen, isOutsideWindow = _a.isOutsideWindow;
        return classnames_1.default('fds-typeahead-content', {
            'fds-position-content': isOpen && isOutsideWindow
        });
    };
    Typeahead.prototype.getLabelContent = function () {
        var _a = this.props, fieldLabel = _a.fieldLabel, name = _a.name, otherProps = _a.otherProps;
        var input = react_1.default.createElement("input", __assign({ ref: this.refInput, className: this.getInputClassNames(), type: "text", title: name, placeholder: fieldLabel ? ' ' : name, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur }, otherProps));
        var fieldLabelContent = (react_1.default.createElement(react_1.default.Fragment, null,
            input,
            react_1.default.createElement("span", { className: 'fds-field-label' }, fieldLabel)));
        return fieldLabel ? fieldLabelContent : input;
    };
    Typeahead.prototype.render = function () {
        var _this = this;
        ExperimentalComponentUtils_1.logExperimentalComponent('typeahead');
        var _a = this.props, classes = _a.classes, invalid = _a.invalid, searchText = _a.searchText, sourceDataValue = _a.sourceDataValue, suggestionList = _a.suggestionList, validationMessage = _a.validationMessage, wrapResults = _a.wrapResults, fieldLabel = _a.fieldLabel;
        var suggestions = this.state.isCancel || this.state.isClearSuggestions ? [] : suggestionList || (this.state && this.state.suggestionList);
        var searchQuery = this.state.searchQuery;
        this.state.isOpen ?
            document.documentElement.classList.add('fds-fullscreen-view', 'fds-typeahead-open') :
            document.documentElement.classList.remove('fds-fullscreen-view', 'fds-typeahead-open');
        return (react_1.default.createElement("div", { className: this.getClassNames(classes, suggestions, wrapResults) },
            react_1.default.createElement("label", { ref: this.refLabel, className: classnames_1.default('fds-field', { 'has-icon': !fieldLabel }, { invalid: invalid }, { 'has-no-placeholder': fieldLabel, 'has-floated-label': fieldLabel }) },
                this.getLabelContent(),
                react_1.default.createElement(Icon_1.default, { name: "arrow-back", classes: "fds-typeahead-back-icon fds-field-icon", onClick: this.onBack }),
                react_1.default.createElement(Icon_1.default, { name: "cancel", classes: "fds-typeahead-cancel-icon fds-field-icon", onClick: this.onCancel }),
                react_1.default.createElement(ValidationMessage_1.default, { validationState: invalid ? FieldValidationState_1.FieldValidationState.INVALID : FieldValidationState_1.FieldValidationState.NONE, validationMessage: validationMessage })),
            suggestions && (react_1.default.createElement("div", { ref: this.typeaheadContent, className: this.getContentWrapperClassNames() },
                react_1.default.createElement(menu_list_1.MenuList, null, suggestions.map(function (item, i) {
                    return (item && (react_1.default.createElement(menu_list_1.MenuListItem, { classes: "fds-typeahead-list-item", key: i, onClick: function () { return _this.onSelect(item); } }, item[sourceDataValue] === 'search' ?
                        _this.searchItem(searchText, searchQuery) : _this.suggestionTextFormatted(item[sourceDataValue], searchQuery))));
                }, this))))));
    };
    Typeahead.defaultProps = {
        sourceData: [],
        searchTermThrottle: 1,
        wrapResults: true
    };
    return Typeahead;
}(react_1.default.Component));
exports.default = Typeahead;
